import SmoothScroll from "./smooth-scroll";
import "./navigation";
import btnToTop from "./to-top-btn";

(() => {
  const init = () => {
    SmoothScroll(-32);
    btnToTop();
  };

  window.addEventListener("load", () => {
    init();
  });
})();
